var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { ExportLogType, getExportLogType } from '../../enum';
import { Autocomplete, DatePicker, ErrorMessageBox } from '../common';
import { FormField } from '../common/formField';
import { TaskStatus } from '../hooks';
import { useCreateExportLogAPI } from './selectors';
var defaultValues = {
    start: moment().utc().startOf('y'),
    end: moment().utc(),
    export_type: ExportLogType.PlatformAdministration,
};
export var ExportLogDialog = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose;
    var t = useTranslation(['manageUser', 'translation']).t;
    var _c = useCreateExportLogAPI(), exportData = _c[0], fetchExportData = _c[1], clearExportData = _c[2];
    var validateForm = yup.object().shape({
        start: yup.object().nullable().required(),
        end: yup.object().nullable().required(),
        startError: yup.string().optional().max(0, 'Invalid'),
        endError: yup.string().optional().max(0, 'Invalid'),
    });
    var _d = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(validateForm),
    }), control = _d.control, watch = _d.watch, reset = _d.reset, handleSubmit = _d.handleSubmit;
    var start = watch().start;
    useEffect(function () {
        if (open) {
            reset(defaultValues);
        }
    }, [open, reset]);
    var handleFormSubmit = function (formData) {
        var payload = __assign(__assign({}, formData), { start: formData.start.clone().utc().startOf('day'), end: formData.end.clone().utc().endOf('day') });
        fetchExportData(payload);
    };
    useEffect(function () {
        var _a;
        if (((_a = exportData.data) === null || _a === void 0 ? void 0 : _a.status) === TaskStatus.Completed) {
            onClose();
        }
    }, [(_b = exportData.data) === null || _b === void 0 ? void 0 : _b.status, onClose]);
    var handleClose = function () {
        var _a;
        if (((_a = exportData.data) === null || _a === void 0 ? void 0 : _a.status) === TaskStatus.Failed) {
            clearExportData();
        }
        onClose();
    };
    return (_jsx(Dialog, __assign({ open: open, onClose: handleClose }, { children: _jsxs(Box, __assign({ component: "form", onSubmit: handleSubmit(handleFormSubmit) }, { children: [_jsx(DialogTitle, __assign({ variant: "h2" }, { children: t('exportLog.title') })), _jsxs(DialogContent, { children: [_jsx(Typography, __assign({ variant: "body1" }, { children: t('exportLog.subtitle') })), _jsx(ErrorMessageBox, { errors: [exportData.error] }), _jsxs(Grid, __assign({ container: true, spacing: 4, marginTop: 4 }, { children: [_jsx(Grid, __assign({ item: true, xs: 6 }, { children: _jsx(FormField, __assign({ name: "export_type", label: t('exportLogTypeTitle'), control: control, required: true }, { children: _jsx(Autocomplete, { options: getExportLogType() }) })) })), _jsx(Grid, { item: true, xs: 6 }), _jsx(Grid, __assign({ item: true, xs: 6 }, { children: _jsx(FormField, __assign({ required: true, name: "start", label: t('exportLog.startDate'), control: control }, { children: _jsx(DatePicker, { disableFuture: true, control: control }) })) })), _jsx(Grid, __assign({ item: true, xs: 6 }, { children: _jsx(FormField, __assign({ required: true, name: "end", label: t('exportLog.endDate'), control: control }, { children: _jsx(DatePicker, { minDate: start, disableFuture: true, control: control }) })) }))] }))] }), _jsxs(DialogActions, __assign({ sx: { justifyContent: 'space-between' } }, { children: [_jsx(Button, __assign({ variant: "outlined", onClick: handleClose }, { children: t('translation:action.cancel') })), _jsx(LoadingButton, __assign({ variant: "contained", type: "submit", loading: exportData.requesting }, { children: t('translation:action.export') }))] }))] })) })));
};
